import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles.css";

const CustomSlider = ({ children }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: (dots) => <CustomDots dots={dots} />,
    customPaging: (i) => <div className="custom-dot">{i + 1}</div>,
  };

  return <Slider {...settings}>{children}</Slider>;
};

export default CustomSlider;

const NextArrow = ({ onClick }) => (
  <img
    src="/ui/images/Truman-UI-Slick-Next.svg"
    onClick={onClick}
    className="custom-next-arrow"
  />
);

const PrevArrow = ({ onClick }) => (
  <img
    src="/ui/images/Truman-UI-Slick-Prev.svg"
    onClick={onClick}
    className="custom-prev-arrow"
  />
);

const CustomDots = ({ dots }) => (
  <div className="custom-dots">
    {dots.map((dot, index) => (
      <div key={index} className={`custom-dot ${dot.props.className}`}></div>
    ))}
  </div>
);
